import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onBlur", "splitter", "showLength", "maxLength"];
import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
import { MultipleInputContext } from '../tools/multipleInput';
import MultipleBaseInput, { canElementTriggerEvent } from '../MultipleBaseInput';
import CInput from '../CInput';
var DefaultValue = {
  tags: [],
  input: ''
};
export default function MultipleInput(_ref, _ref2) {
  var _value;

  var state = _ref.state,
      value = _ref.value,
      change = _ref.change,
      setRef = _ref.setRef;

  var _onBlur = _ref2.onBlur,
      _ref2$splitter = _ref2.splitter,
      splitter = _ref2$splitter === void 0 ? /[\t ,]/ : _ref2$splitter,
      showLength = _ref2.showLength,
      maxLength = _ref2.maxLength,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  value = (_value = value) !== null && _value !== void 0 ? _value : DefaultValue;
  var _value2 = value,
      tags = _value2.tags,
      input = _value2.input;
  var tagsLength = tags.length;
  var noTags = tagsLength === 0;

  var _MultipleInputContext = MultipleInputContext({
    state: state
  }),
      checkPaste = _MultipleInputContext.checkPaste,
      onUpdate = _MultipleInputContext.onUpdate,
      onPaste = _MultipleInputContext.onPaste,
      inputClassName = _MultipleInputContext.inputClassName;

  return {
    className: classNames('jmtd-multiple-input', {
      'jmtd-multiple-input-no-tag': noTags
    }),
    defaultValue: DefaultValue,
    Wrapper: MultipleBaseInput,
    onUpdate: onUpdate,
    canElementTriggerFocus: canElementTriggerEvent,
    contentProps: {
      showLength: showLength,
      maxLength: maxLength,
      empty: noTags && !input,
      onToggleExpand: function onToggleExpand() {
        document.activeElement && document.activeElement.blur();
      },
      tags: tags.map(function (str, index) {
        return {
          closable: true,
          onClose: function onClose() {
            var next = tags.filter(function (_, tagIndex) {
              return tagIndex !== index;
            });
            change({
              tags: next,
              input: input
            });
            return next.length === 0;
          },
          children: str
        };
      }),
      onCloseAll: function onCloseAll() {
        change({
          tags: [],
          input: ''
        });
        return true;
      },
      children: /*#__PURE__*/React.createElement(CInput, _extends({
        setRef: setRef,
        onChange: function onChange(e) {
          var currentValue = e.currentTarget.value;
          var splitResult = currentValue.split(splitter);
          var nextInput = checkPaste() ? '' : splitResult.pop();
          change({
            tags: tags.concat(splitResult).filter(function (item) {
              return !!item;
            }),
            input: nextInput
          });
        },
        onBlur: function onBlur(e) {
          if (input) {
            change({
              tags: tags.concat(input),
              input: ''
            });
          }

          _onBlur(e);
        },
        onKeyDown: function onKeyDown(_ref3) {
          var key = _ref3.key;

          // 删除Tag
          if (key === 'Backspace' && !input) {
            if (tagsLength) {
              change({
                tags: tags.slice(0, tagsLength - 1),
                input: ''
              });
            }
          } // 转换tag


          if (key === 'Enter' && input) {
            change({
              tags: tags.concat(input),
              input: ''
            });
          }
        },
        onPaste: onPaste,
        value: input,
        className: inputClassName
      }, otherProps))
    }
  };
}